import { Component } from '@angular/core';

@Component({
  selector: 'app-subnavigation-demo',
  templateUrl: './subnavigation-demo.component.html',
})
export class SubnavigationDemoComponent {}
